import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";

import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import smartSolutionsIcon from "../assets/images/icons/cloud-refresh.png";
import OperationalEfficiencyIcon from "../assets/images/icons/enterprise.png";
import EnterpriseProvenIcon from "../assets/images/icons/enterprise.png";
import ComplianceAndSecurityFirstIcon from "../assets/images/icons/complaint.png";
import CrossChannelIntelligenceIcon from "../assets/images/icons/network-connection.png";

import bannerShape1 from "../assets/images/layers/banner_layer_one.png";
import bannerShape2 from "../assets/images/layers/banner_layer_two.png";
import smartSolutions from "../assets/images/banner/smart-solutions.png";
import SmartSolutionsModal from "./SmartSolutionsModal";
import BookAConsultationModal from "./BookAConsultationModal";

const SmartSolutions = () => {
  const [showSmartSolutionsModal, setShowSmartSolutionsModal] = useState(false);
  const [showBookConsultationModal, setShowBookConsultationModal] =
    useState(false);

  const closeSmartSolutionsModal = () => setShowSmartSolutionsModal(false);

  const openBookConsultationModal = () => setShowBookConsultationModal(true);
  const closeBookConsultationModal = () => setShowBookConsultationModal(false);

  return (
    <>
      <header class="masthead z-0 pt-5 pb-5">
        <div class="container">
          <Image
            src={bannerShape1}
            className="z-n1 position-absolute top-0 end-0 opacity-25 w-40 d-none d-md-block"
          />
          <Row className="align-items-center justify-content-between">
            <Col lg="7">
              <div className="pe-3">
                <div class="masthead-heading fw-800 text-black mb-2">
                  Smart Solutions{" "}
                </div>
                <div className="red-divider"></div>
                <p className="text-black ls-minus-045 fw-800 fs-24 mb-1 mt-4">
                  Purpose-built accelerators to elevate data quality,
                  personalization, and marketing performance across your
                  Salesforce ecosystem.
                </p>
                <p className="mt-4 mb-4 lh-base">
                  Empower your business with a suite of enterprise-grade
                  solutions engineered to optimize Data Cloud, Marketing Cloud,
                  and Personalization.
                </p>
                <p className="mt-4 mb-4 lh-base">
                  Achieve cleaner data, smarter engagement, lower costs, and
                  faster time-to-value.
                </p>
                <div className="d-block d-sm-flex gap-2">
                  <Nav.Link
                    as={Link}
                    to="/contact"
                    className="mb-2 text-white btn btn-danger btn-xl me-3"
                  >
                    Request a Demo
                  </Nav.Link>
                </div>
              </div>
            </Col>
            <Col lg="5" className="text-center">
              <Image
                src={smartSolutions}
                className="m-auto"
                style={{ width: "90%" }}
              />
            </Col>
          </Row>
          <Image
            src={bannerShape2}
            className="position-absolute bottom-0 end-0 w-40 d-none d-md-block bannerShapeBottom"
          />
        </div>
      </header>

      <section className="page-section bg-EFFDFF pt-80 pb-80">
        <Container>
          <Row className="align-items-start">
            <Col lg={12}>
              <h2 class="section-heading fw-700 fs-2 mb-3">
                <span className="bordered-text bordered-text-start">
                  Our Solutions
                </span>
              </h2>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
                  Data Cloud Maturity Assessment
                </h5>
                <p className="mb-3 fs-6">
                  A structured three-week program to benchmark your readiness
                  and identify priority value drivers.
                </p>
                <h6 className="fw-600 fs-6 mb-2">What you gain</h6>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Comprehensive audit of Martech stack, data ecosystem and
                    digital maturity
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Mapping of key journeys and MVP opportunities
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Clear recommendations, schema designs and actionable next
                    steps
                  </li>
                </ul>
                <div className="mt-auto">
                  <Nav.Link
                    as={Link}
                    to="/data-cloud-maturity-assessment"
                    className="d-inline-block text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  >
                    Learn More
                  </Nav.Link>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
                  AppLink™ — Flutter SDK for Salesforce Personalization
                </h5>
                <p className="mb-3 fs-6">
                  The industry&apos;s first Flutter SDK enabling real-time
                  personalization in mobile apps.
                </p>
                <h6 className="fw-600 fs-6 mb-2">Key capabilities</h6>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Native integration with Salesforce MCP
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Unified session management and behavioral event tracking
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Plug-and-play personalized banners, carousels and content
                    blocks
                  </li>
                </ul>
                <div className="mt-auto">
                  <Nav.Link
                    as={Link}
                    to="/applink-flutter-sdk-for-salesforce-personalization"
                    className="d-inline-block text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  >
                    Discover AppLink
                  </Nav.Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
                  AWS Middleware for Salesforce Data Cloud
                </h5>
                <p className="mb-3 fs-6">
                  An AWS-native pre-processing and transformation layer to lower
                  ingestion costs and enhance performance.
                </p>
                <h6 className="fw-600 fs-6 mb-2">Value delivered</h6>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    40%+ reduction in Data Cloud credit consumption
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Cleaner, enriched, activation-ready data
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Real-time and batch processing support.
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Serverless scalability with AWS Lambda, Glue, S3 and
                    Redshift.
                  </li>
                </ul>
                <div className="mt-auto">
                  <Nav.Link
                    as={Link}
                    to="/aws-middleware-for-salesforce-data-cloud"
                    className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  >
                    Learn More
                  </Nav.Link>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
                  Data De-duplication Engine for Salesforce Data Cloud (PySpark)
                </h5>
                <p className="mb-3 fs-6">
                  An ML-powered data cleaning and deduplication layer built for
                  high-volume Data Cloud environments.
                </p>
                <h6 className="fw-600 fs-6 mb-2">Key capabilities</h6>
                <ul
                  className="custom-ul mb-4 ps-0
                "
                >
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Automated standardization and fuzzy matching.
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    99%+ accuracy in eliminating duplicates
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    3× faster processing on distributed PySpark
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Industry-ready compliance templates
                  </li>
                </ul>
                <div className="mt-auto">
                  <Nav.Link
                    as={Link}
                    to="/data-deduplication-engine-for-salesforce-data-cloud"
                    className="d-inline-block text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  >
                    Learn More
                  </Nav.Link>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
                  LyncSense — Link Shortener &amp; Tracking for Salesforce
                  Marketing Cloud
                </h5>
                <p className="mb-3 fs-6">
                  A Salesforce-ready link management engine purpose-built for
                  SMS, email and journeys.
                </p>
                <h6 className="fw-600 fs-6 mb-2">Highlights</h6>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Auto-shortening within Marketing Cloud workflows.
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Real-time click analytics and device insights.
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Custom domains and central performance dashboards.
                  </li>
                </ul>
                <div className="mt-auto">
                  <Nav.Link
                    href="https://app.trym.ly/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-inline-block text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  >
                    See How It Works
                  </Nav.Link>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mb-4">
              <div className="white-card box-shadow-one bg-white rounded-3 p-4 h-100 d-flex flex-column">
                <h5 className="fw-700 fs-5 mb-2">
                  Kleanmail – Email Verification for Marketing & CRM
                </h5>
                <p className="mb-3 fs-6">
                  An AI-powered email validation and hygiene layer to improve
                  deliverability and reduce bounce rates.
                </p>
                <h6 className="fw-600 fs-6 mb-2">Value delivered</h6>
                <ul className="custom-ul mb-4 ps-0">
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    98% accuracy in identifying invalid and risky emails
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Reduced bounce rates and improved sender reputation
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Real-time and batch validation support
                  </li>
                  <li className="ls-minus036 fs-12 mb-1 fw-400">
                    Seamless API integration with forms, CRM, and campaigns
                  </li>
                </ul>
                <div className="mt-auto">
                  <Nav.Link
                    href="https://www.kleanmail.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-inline-block text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                  >
                    Get Started
                  </Nav.Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section bg-white pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-5">
            <Col>
              <div className="text-center d-flex align-items-center justify-content-center">
                <h2 className="section-heading section-heading-center fw-700 fs-2">
                  Why Businesses Choose{" "}
                  <span className="bordered-text">Comsense</span>?
                </h2>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center mt-4 justify-content-center position-relative">
            <Col lg={5} md={6}>
              <div className="mb-4 mb-lg-4 d-flex align-items-center">
                <div>
                  <div className="blue-gradient-sqr-icon text-center position-relative">
                    <img
                      width={30}
                      className="m-auto"
                      src={ComplianceAndSecurityFirstIcon}
                      alt="Customer 360 View"
                    />
                  </div>
                </div>
                <div className="content ms-4 pe-3">
                  <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                    Compliance & Security-First
                  </h5>
                  <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                    GDPR-, CCPA-, and PCI-ready models with enterprise-grade
                    data governance.{" "}
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={5} md={6}>
              <div className="mb-4 mb-lg-4 d-flex align-items-center">
                <div>
                  <div className="blue-gradient-sqr-icon text-center position-relative">
                    <img
                      width={30}
                      className="m-auto"
                      src={EnterpriseProvenIcon}
                      alt="Segmentation and Activation"
                    />
                  </div>
                </div>
                <div className="content ms-4 pe-3">
                  <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                    Enterprise-Proven
                  </h5>
                  <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                    Adopted by leading brands across BFSI, Retail, Automotive,
                    and Real Estate.{" "}
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={5} md={6}>
              <div className="mb-4 mb-lg-4 d-flex align-items-center">
                <div>
                  <div className="blue-gradient-sqr-icon text-center position-relative">
                    <img
                      width={30}
                      className="m-auto"
                      src={OperationalEfficiencyIcon}
                      alt="Data Ingestion & Unification"
                    />
                  </div>
                </div>
                <div className="content ms-4 pe-3">
                  <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                    Operational Efficiency
                  </h5>
                  <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                    Lower manual effort, reduce marketing costs, and accelerate
                    activation cycles.{" "}
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={5} md={6}>
              <div className="mb-4 mb-lg-4 d-flex align-items-center">
                <div>
                  <div className="blue-gradient-sqr-icon text-center position-relative">
                    <img
                      width={30}
                      className="m-auto"
                      src={CrossChannelIntelligenceIcon}
                      alt="Calculated Insights"
                    />
                  </div>
                </div>
                <div className="content ms-4 pe-3">
                  <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                    Cross-Channel Intelligence
                  </h5>
                  <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                    Enable real-time, connected experiences across mobile, web,
                    and offline touchpoints.{" "}
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={5} md={6}>
              <div className="mb-4 mb-lg-4 d-flex align-items-center">
                <div>
                  <div className="blue-gradient-sqr-icon text-center position-relative">
                    <img
                      width={30}
                      className="m-auto"
                      src={smartSolutionsIcon}
                      alt="Data Audit & Strategy"
                    />
                  </div>
                </div>
                <div className="content ms-4 pe-3">
                  <h5 className="mb-2 fw-600 fs-4 ls-minus-05">
                    Tailored for Salesforce
                  </h5>
                  <p className="fw-500 fs-6 mb-0 ls-minus-02 text-2C354CB2">
                    Designed to extend and enhance Data Cloud, Marketing Cloud,
                    and Personalization capabilities.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={5} md={6}></Col>
          </Row>

          <Row className="align-items-center mt-5 justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h3 className="fw-700 fs-4 mb-2">
                  Ready to transform your Salesforce experience?
                </h3>
                <p className="fs-6 mb-3">
                  Discover how Smart Solutions can help your organization unlock
                  efficiency, intelligence and long-term value.
                </p>
                <Nav.Link
                  onClick={openBookConsultationModal}
                  className="btn btn-danger btn-xl ls-0 fw-600 d-inline-block"
                >
                  Book a Consultation
                </Nav.Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Modal
        show={showSmartSolutionsModal}
        onHide={closeSmartSolutionsModal}
        size="xl"
        centered
      >
        <style>
          {`.btn-close {
           position: absolute;
           top: 1rem;
           right: 1rem;
           z-index: 2;
         }
         .modal-content{overflow:hidden !important;}
         `}
        </style>

        <Modal.Header closeButton className="p-0" />
        <Modal.Body className="p-0">
          <SmartSolutionsModal />
        </Modal.Body>
      </Modal>

      <Modal
        show={showBookConsultationModal}
        onHide={closeBookConsultationModal}
        size="xl"
        centered
      >
        <style>
          {`.btn-close {
           position: absolute;
           top: 1rem;
           right: 1rem;
           z-index: 2;
         }
         .modal-content{overflow:hidden !important;}
         `}
        </style>

        <Modal.Header closeButton className="p-0" />
        <Modal.Body className="p-0">
          <BookAConsultationModal />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SmartSolutions;
